import React, {Component, Fragment} from 'react';
import {translate} from 'react-i18next';
import * as Moment from 'moment';
import 'moment/locale/de';
import {extendMoment} from 'moment-range';
import $ from "jquery";
import {Scrollbars} from 'react-custom-scrollbars';
import EditLocation from "../../components/elements/locationGroups/EditLocation";
import {getSchedule} from "../../actions/scheduleAction";
import {openDialog as openAddLocationDialog} from "../../actions/addLocationAction";
import {appDialogAddShiftOpen, appDialogShiftDetailsOpen} from "../../actions/appAction";
import {connect} from "react-redux";
import {Dropdown, MenuItem} from "react-bootstrap";
import ShiftImporter from "./ShiftImporter";
import DeleteShifts from "./DeleteShifts";
import ScheduleApi from "../../apis/ScheduleApi";
import fileDownload from 'js-file-download';

const moment = extendMoment(Moment);

class Schedule extends Component {

    state = {
        hoursTop: 0,
        initialLoaded: false,
        activeHour: 0,
        currentLeft: -1,
        workTypesFilter: [],
        locationGroupsFilter: [],
        freeTextFilter: ''
    };

    locationsEl = null;
    locationShiftsEl = null;
    currentLeftInterval = null;

    componentDidMount() {
        let that = this;
        this.props.getSchedule();
        this.scrollToCurrent();

        $('.ScheduleScreen').scroll(function () {
            that.setState({
                hoursTop: $(this).scrollTop()
            });
        });

        this.locationsEl = document.getElementsByClassName('locations')[0];
        this.locationShiftsEl = document.getElementsByClassName('locationShifts')[0];
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let locationsWidth = $('.ScheduleScreen .locations').width();
        let actionsWidth = locationsWidth > 220 ? locationsWidth : 220;
        $('.ScheduleScreen .locations .actions').width(actionsWidth);
        if (actionsWidth > locationsWidth) $('.ScheduleScreen .locations').css('minWidth', actionsWidth);
        let $shifts = $('.ScheduleScreen .shifts');
        $('.ScheduleScreen .shifts > div:nth-of-type(2)').width($shifts.width());
        if (!this.state.initialLoaded && this.props.schedule.startAt) {
            this.setState({
                initialLoaded: true
            });
            this.scrollToCurrent();
        }
        if (this.props.schedule.loaded && (this.props.schedule.startAt !== prevProps.schedule.startAt || this.state.currentLeft === -1)) {
            this.showCurrentTimeGrid();
            this.currentLeftInterval = setInterval(this.showCurrentTimeGrid, 60000);
        }
    }

    componentWillUnmount() {
        if (this.currentLeftInterval) {
            clearInterval(this.currentLeftInterval);
        }
    }

    showCurrentTimeGrid = () => {
        if (this.props.schedule.loaded && this.props.schedule.startAt) {
            let currentLeft = moment.duration(moment().diff(this.props.schedule.startAt)).asMinutes() * 0.5;
            this.setState({currentLeft: Math.round(currentLeft)});
        }
    };

    scrollToCurrent = () => {
        if (this.props.schedule.startAt) {
            let left = moment.range(this.props.schedule.startAt, moment()).valueOf() / 1000 / 60 / 60 * 30 - 120;
            this.refs.scheduleScrollbar.scrollLeft(left);
        }
    };

    handleOpenShiftDetails = (shiftId) => {
        this.props.openShiftDetailsDialog(shiftId);
    };

    createShiftOccupancyClass = (supporterAmount, slots) => {
        let className = "shift-occupancy-";
        let percent = supporterAmount / slots;
        if (percent > 2) {
            className += "overloaded-extreme";
        } else if (percent > 1) {
            className += "overloaded";
        } else if (percent === 1) {
            className += "perfect";
        } else if (percent > 0.8) {
            className += "okay";
        } else if (percent > 0.3) {
            className += "danger";
        } else {
            className += "danger-total";
        }
        return className;
    };

    calcHour = (e) => {
        if (this.locationsEl && this.locationShiftsEl) {
            let startLeft = this.locationsEl.getBoundingClientRect().left + this.locationsEl.clientWidth;
            let shiftsLeft = this.locationShiftsEl.getBoundingClientRect().left - startLeft;
            let x = (e.pageX - startLeft) - shiftsLeft;
            this.setState({activeHour: Math.round(x / 30)});
        }
    };

    filterLocations = (el) => {
        if (this.state.workTypesFilter.length > 0) {
            if (!this.state.workTypesFilter.find(wtf => el.workType.id === wtf)) return false;
        }
        if (this.state.locationGroupsFilter.length > 0) {
            if (!this.state.locationGroupsFilter.find(lgf => el.locationGroup.id === lgf)) return false;
        }
        if (this.state.freeTextFilter.length > 0) {
            let searchStringParts = this.state.freeTextFilter.split(" ");
            let foundSearchString = true;
            for (let j = 0; j < searchStringParts.length; j++) {
                foundSearchString = foundSearchString && (el.name.toLowerCase().indexOf(searchStringParts[j].toLowerCase()) !== -1 || el.locationGroup.name.toLowerCase().indexOf(searchStringParts[j].toLowerCase()) !== -1 || el.workType.name.toLowerCase().indexOf(searchStringParts[j].toLowerCase()) !== -1);
            }
            if (!foundSearchString) return false;
        }
        return true
    };

    exportShifts = () => {
        ScheduleApi.exportShifts()
            .then(response => {
                if (response.status === 200) {
                    fileDownload(response.data, `shift_export_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                }
            })
    }

    render() {

        const {t, authorization, scope} = this.props;

        const {schedule} = this.props;
        const range = schedule.loaded ? moment.range(schedule.startAt, schedule.endAt) : null;
        const hours = schedule.loaded ? Array.from(range.by('hour')) : null;
        const range2 = schedule.loaded ? moment.range(moment(schedule.startAt).startOf('day'), moment(schedule.endAt).startOf('day')) : null;
        const days = schedule.loaded ? Array.from(range2.by('day')) : null;
        const locations = schedule.locations ? schedule.locations.filter(this.filterLocations) : null;
        return (
            <div className="ScheduleScreen">
                {schedule.loaded ? (
                    <div className="locations">
                        <div className="actions gray-bg">
                            {schedule.loading ? (
                                <div className="sk-spinner sk-spinner-rotating-plane"/>
                            ) : null}
                            <button className="pull-right btn btn-success btn-xs m-r-xs m-t-xs"
                                    onClick={this.scrollToCurrent}>
                                <i className="fa fa-angle-double-down"/>
                            </button>
                            {authorization.roles.find((role) => role === 'ROLE_SHIFT_ADMIN') ? (
                              <Dropdown id="schedule-top-menu">
                                  <Dropdown.Toggle>
                                      <i className="fa fa-bars"/>
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                      <MenuItem onClick={this.props.openAddShiftDialog}>
                                          {t('schedule.buttons.addShift')}
                                      </MenuItem>
                                      <MenuItem onClick={this.props.openAddLocationDialog}>
                                          {t('schedule.buttons.addLocation')}
                                      </MenuItem>
                                      {authorization.roles.find((role) => role === 'ROLE_ADMIN') ? (
                                        <Fragment>
                                            <ShiftImporter/>
                                            <MenuItem onClick={this.exportShifts}>
                                                {t('schedule.buttons.exportShifts')}
                                            </MenuItem>
                                            <DeleteShifts/>
                                        </Fragment>
                                      ) : null}
                                  </Dropdown.Menu>
                              </Dropdown>
                            ) : null}
                            {scope.full && scope.full.scheduleFilters ? (
                                <Fragment>
                                    <Dropdown id="schedule-filter-menu">
                                        <Dropdown.Toggle>
                                            <i className="fa fa-filter"/>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <li className="p-md" style={{minWidth: '50vw'}}>
                                                <div className="row">
                                                    {scope.full.scheduleFilters.includes('WORK_TYPE_WITH_SECURITY_GROUPS') && schedule.workTypes ? (
                                                        <div className="col-xs-6">
                                                            <h4>
                                                                {t('schedule.filters.workTypeWithSecurityGroups.title')}
                                                            </h4>
                                                            <div>
                                                                <label>
                                                                    <input type="checkbox"
                                                                           checked={schedule.workTypes.filter(el => el.name.startsWith('secu') && this.state.workTypesFilter.find(wtf => wtf === el.id)).length === schedule.workTypes.filter(el => el.name.startsWith('secu')).length}
                                                                           onChange={e => e.target.checked ? this.setState({workTypesFilter: [...this.state.workTypesFilter, ...schedule.workTypes.filter(el => el.name.startsWith('secu')).map(el => el.id)]}) : this.setState({workTypesFilter: schedule.workTypes.filter(el => !el.name.startsWith('secu') && this.state.workTypesFilter.includes(el.id)).map(el => el.id)})}/>
                                                                    &nbsp;{t('schedule.filters.workTypeWithSecurityGroups.group_secu')}
                                                                </label>
                                                                <div className="m-l-md">
                                                                    {schedule.workTypes ? schedule.workTypes.filter(el => el.name.startsWith('secu')).map((wt, wtI) => (
                                                                        <label style={{
                                                                            whiteSpace: 'nowrap',
                                                                            display: 'block'
                                                                        }} key={wtI}>
                                                                            <input type="checkbox"
                                                                                   onChange={(e) => e.target.checked ? this.setState({workTypesFilter: [...this.state.workTypesFilter, wt.id]}) : this.setState({workTypesFilter: this.state.workTypesFilter.filter(el => el !== wt.id)})}
                                                                                   checked={this.state.workTypesFilter.find(el => el === wt.id)}/>
                                                                            <span
                                                                                style={{whiteSpace: 'nowrap'}}>&nbsp;{wt.name}</span>
                                                                        </label>
                                                                    )) : null}
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label>
                                                                    <input type="checkbox"
                                                                           checked={schedule.workTypes.filter(el => el.name.startsWith('ordner') && this.state.workTypesFilter.find(wtf => wtf === el.id)).length === schedule.workTypes.filter(el => el.name.startsWith('ordner')).length}
                                                                           onChange={e => e.target.checked ? this.setState({workTypesFilter: [...this.state.workTypesFilter, ...schedule.workTypes.filter(el => el.name.startsWith('ordner')).map(el => el.id)]}) : this.setState({workTypesFilter: schedule.workTypes.filter(el => !el.name.startsWith('ordner') && this.state.workTypesFilter.includes(el.id)).map(el => el.id)})}/>
                                                                    &nbsp;{t('schedule.filters.workTypeWithSecurityGroups.group_ordner')}
                                                                </label>
                                                                <div className="m-l-md">
                                                                    {schedule.workTypes ? schedule.workTypes.filter(el => el.name.startsWith('ordner')).map((wt, wtI) => (
                                                                        <label style={{
                                                                            whiteSpace: 'nowrap',
                                                                            display: 'block'
                                                                        }} key={wtI}>
                                                                            <input type="checkbox"
                                                                                   onChange={(e) => e.target.checked ? this.setState({workTypesFilter: [...this.state.workTypesFilter, wt.id]}) : this.setState({workTypesFilter: this.state.workTypesFilter.filter(el => el !== wt.id)})}
                                                                                   checked={this.state.workTypesFilter.find(el => el === wt.id)}/>
                                                                            <span
                                                                                style={{whiteSpace: 'nowrap'}}>&nbsp;{wt.name}</span>
                                                                        </label>
                                                                    )) : null}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : ''}
                                                    {scope.full.scheduleFilters.includes('LOCATION_GROUP') && schedule.locationGroups ? (
                                                        <div className="col-xs-6">
                                                            <h4>
                                                                {t('schedule.filters.locationGroups.title')}
                                                            </h4>
                                                            <div>
                                                                {schedule.locationGroups ? schedule.locationGroups.map((lg, lgI) => (
                                                                    <label
                                                                        style={{whiteSpace: 'nowrap', display: 'block'}}
                                                                        key={lgI}>
                                                                        <input type="checkbox"
                                                                               checked={this.state.locationGroupsFilter.includes(lg.id)}
                                                                               onChange={e => e.target.checked ? this.setState({locationGroupsFilter: [...this.state.locationGroupsFilter, lg.id]}) : this.setState({locationGroupsFilter: this.state.locationGroupsFilter.filter(el => el !== lg.id)})}/>
                                                                        <span
                                                                            style={{whiteSpace: 'nowrap'}}>&nbsp;{lg.name}</span>
                                                                    </label>
                                                                )) : null}
                                                            </div>
                                                        </div>
                                                    ) : ''}
                                                </div>
                                            </li>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    {scope.full.scheduleFilters.includes('FREETEXT') ? (
                                        <input type="text" value={this.state.freeTextFilter}
                                               onChange={(e) => this.setState({freeTextFilter: e.target.value})}
                                               className="form-control"
                                               placeholder={`${t('schedule.filters.freeText.title')}...`}/>
                                    ) : null}
                                </Fragment>
                            ) : null}
                        </div>
                        {locations ? locations.map((location, i) => (
                            <div className={"location" + (i === 0 ? ' first' : '')} key={i}
                                 style={{height: location.pipes ? location.pipes.length * 36 : 36}}>
                                {location.stewardsNeeded ? (
                                    <i className="fa fa-shield m-r-xs"/>
                                ) : null}
                                {location.name} <EditLocation id={location.id} handleClose={this.props.getSchedule}/>
                                <div className="small text-muted detail-info">
                                    {scope.full.scheduleLocationInfo ? scope.full.scheduleLocationInfo.map((sli, sliI) => (
                                        <Fragment key={sliI}>
                                            {sliI !== 0 && (sli !== 'COMPANY' || location.company.shortName) ? (
                                                <span>&nbsp;/&nbsp;</span>
                                            ) : null}
                                            {sli === 'LOCATION_GROUP' ? (
                                                <Fragment>
                                                    <i className="fa fa-group"/> {location.locationGroup.name}
                                                </Fragment>
                                            ) : sli === 'ROUTE' ? (
                                                <Fragment>
                                                    <i className="fa fa-road"/> {location.route.name}
                                                </Fragment>
                                            ) : sli === 'WORK_TYPE' ? (
                                                <Fragment>
                                                    <i className="fa fa-ambulance"/> {location.workType.name}
                                                </Fragment>
                                            ) : (sli === 'COMPANY' && location.company.shortName) ? (
                                                <Fragment>
                                                    <i className="fa fa-users"/> {location.company.shortName}
                                                </Fragment>
                                            ) : null}
                                        </Fragment>
                                    )) : null}
                                </div>
                            </div>
                        )) : null}
                    </div>
                ) : null}
                {schedule.loaded ? (
                    <Scrollbars autoHide={true} className="shifts" style={{
                        width: hours.length * 30,
                        height: locations.reduce((acc, val) => (acc + val.pipes.length * 37), 0) + 73
                    }} ref="scheduleScrollbar" onMouseMove={this.calcHour}>
                        <div className="locationShifts" style={{width: hours.length * 30}}>
                            {locations ? locations.map((location, i) => (
                                <div className="locationShift" key={i}
                                     style={{height: location.pipes ? location.pipes.length * 36 : 36}}>
                                    {location.pipes ? location.pipes.map((pipe, j) => (
                                        <div className="pipe" key={i + "-" + j}>
                                            {pipe.map((shift, h) => (
                                                <div key={i + "-" + j + "-" + h}
                                                     className={"shift " + this.createShiftOccupancyClass(shift.supporterAmount, shift.slots)}
                                                     style={{
                                                         left: (moment.range(schedule.startAt, shift.startAt).valueOf() / 1000 / 60 / 60 * 30),
                                                         width: (moment.range(shift.startAt, shift.endAt).valueOf() / 1000 / 60 / 60 * 30)
                                                     }} onClick={() => this.handleOpenShiftDetails(shift.id)}>
                                                    <div className="pull-right">
                                                        {shift.hasComments ? (
                                                            <i className="fa fa-comment"/>
                                                        ) : null}
                                                        {shift.onlyStewards ? (
                                                            <i className="fa fa-shield"/>
                                                        ) : null}
                                                        {shift.importance === 'LOW' ? (
                                                            <i className="fa fa-angle-double-down"/>
                                                        ) : shift.importance === 'MEDIUM_LOW' ? (
                                                            <i className="fa fa-angle-down"/>
                                                        ) : shift.importance === 'MEDIUM_HIGH' ? (
                                                            <i className="fa fa-angle-up"/>
                                                        ) : shift.importance === 'HIGH' ? (
                                                            <i className="fa fa-angle-double-up"/>
                                                        ) : null}
                                                    </div>
                                                    [{shift.onSite}] {shift.supporterAmount} / {shift.slots} ({shift.checkedInAmount})
                                                </div>
                                            ))}
                                        </div>
                                    )) : null}
                                </div>
                            )) : null}
                        </div>
                        <div className="days gray-bg" style={{top: this.state.hoursTop}}>
                            {days ? days.map((day, i) => (
                                <div className="day" key={i}
                                     style={{width: (i === 0 ? (moment.range(schedule.startAt, moment(days[1]).startOf('day')).valueOf() / 1000 / 60 / 60 * 30) : (i === (days.length - 1) ? (moment.range(moment(day).startOf('day'), schedule.endAt).valueOf() / 1000 / 60 / 60 * 30 + 30) : 24 * 30))}}>
                                    {moment(day).format('ddd')}<br/>
                                    {moment(day).format('DD.MM.YY')}
                                </div>
                            )) : null}
                        </div>
                        <div className="hours gray-bg" style={{top: this.state.hoursTop + 36}}>
                            {hours ? hours.map((hour, i) => (
                                <div className="hour" key={i}>
                                    {moment(hour).format('HH')}
                                </div>
                            )) : null}
                        </div>
                        <div className="grids" style={{top: this.state.hoursTop + 34}}>
                            <div className="grid-current" style={{left: this.state.currentLeft}}/>
                            {hours ? hours.map((hour, i) => (
                                <div className={`grid${i === this.state.activeHour ? ' hover' : ''}`} key={i}/>
                            )) : null}
                        </div>
                    </Scrollbars>
                ) : null}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        authorization: state.authorization,
        schedule: state.schedule,
        app: state.app,
        scope: state.scope
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getSchedule: () => {
            dispatch(getSchedule())
        },
        openAddLocationDialog: () => {
            dispatch(openAddLocationDialog());
        },
        openShiftDetailsDialog: (shiftId) => {
            dispatch(appDialogShiftDetailsOpen(shiftId))
        },
        openAddShiftDialog: () => {
            dispatch(appDialogAddShiftOpen())
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(translate()(Schedule));
